export default "__VITE_ASSET__4f67d053__"